import { createContext } from "react";

// Standalone search blocks show tags; search pages supply their editor setting.
export const SearchPageTagFilterContext = createContext(true);
